import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setShouldNavigateForward } from '../../Lib/redux/slices/navigationControls';
import { setAdvancePageStatus } from '../../Lib/redux/slices/sessionDataPopulation';
import { ComponentsWithoutCustomerInput } from '../../Data/Components';

const isHiddenInChameleon = (input) => {
  return input.hiddenInChameleon ? input.hiddenInChameleon : false;
};

/**
 * This hook handles navigation following receiving session data
 *
 * i.e. if we are sent a batch of session data this hook will take us to the next page with incomplete input components.
 */

const useAdvanceToUnansweredQuestion = ({
  advancePageStatus,
  componentsOnPage,
  currentPage,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (advancePageStatus === 'start') {
      const pageInputComponents = {};
      Object.entries(componentsOnPage).forEach(([key, value]) => {
        if (
          !ComponentsWithoutCustomerInput.includes(value.component.type) &&
          (!value.component?.isVisible === false ||
            value.component.isVisible === undefined) &&
          !isHiddenInChameleon(value.input)
        ) {
          pageInputComponents[key] = value;
        }
      });

      const elementsLeftCount = Object.keys(pageInputComponents).length;

      if (elementsLeftCount > 0) {
        const components = Object.values(pageInputComponents);
        const isAnswered = components.every(
          (component) =>
            component.input.value !== '' && component.input.value !== undefined
        );

        if (isAnswered) {
          dispatch(setShouldNavigateForward({ shouldNavigateForward: true }));
        } else {
          dispatch(setAdvancePageStatus({ advancePageStatus: 'finished' }));
        }
      } else {
        dispatch(setAdvancePageStatus({ advancePageStatus: 'finished' }));
      }
    }
  }, [currentPage, advancePageStatus]);
};

export default useAdvanceToUnansweredQuestion;
